import { computed, type Ref } from "vue";
import { useI18n } from "vue-i18n";

import type { Filter } from "@/stores/search/filterSelector";

function useFilterItem(filterMenu: Ref<Filter>, selected: Ref<string[]>) {
  const { t } = useI18n();

  const filterLabel = computed(() => {
    if (!selected.value) return "";
    if (selected.value.length === 0) {
      return `${t("generic.all")} ${filterMenu.value.label}`;
    }
    return filterMenu.value.label;
  });

  function handleFilterChange(option: string) {
    const index = selected.value.findIndex((arr) => {
      return arr === option;
    });

    if (index === -1) {
      selected.value.push(option);
    } else {
      selected.value.splice(index, 1);
    }
  }

  return {
    handleFilterChange,
    filterLabel,
  };
}

export default useFilterItem;
